import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'

export default {
  name: 'ceremony',
  components: {
    SharedHeader,
    SharedFooter
  },
  computed: {
    isSignedIn () {
      return this.$store.getters.isSignedIn
    },
    env () {
      return this.$store.getters.env
    },
    user () {
      return this.$store.getters.user
    }
  },
  data () {
    return {
      smartthon: {
        coverId: '',
        title: ''
      },
      company: {},
      ceremony: {},
      avatar: '',
      loading: true,
      updating: {
        attendance: false,
        absence: false
      },
      isModal: false,
      reason: '',
      error: {}
    }
  },
  mounted () {
    let pathParams = {
      smartthonId: this.$route.params.smartthonId
    }

    let additionalParams = {
      queryParams: {
        enterpriseId: this.user.enterpriseId,
        type: 'ceremony_preview'
      }
    }

    this.$apig.get(this.$store.getters.api.SMARTTHON, pathParams, additionalParams, {})
      .then(response => {
        this.smartthon = response.data.smartthon
        this.ceremony = response.data.ceremony
        this.company = response.data.company
        this.smartthon.cover = `${process.env.S3}/smartthon/${this.$route.params.smartthonId}/cover/${this.smartthon.coverId}.png`
        this.avatar = `${process.env.S3}/enterprise/avatar/${response.data.company.avatarId}.png`

        window.scrollTo(0, 0)
        this.loading = false
      })
      .catch(err => {
        console.log(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/report/ceremony/preview/preview.js